import {
  TOGGLE_SELECTED_PERMISSION,
  INIT_PERMISSIONS_SELECTION,
  TOGGLE_SELECTED_PERMISSIONS
} from './action-types';

/**
 * Funcion que se encarga de actualzar el permiso a "seleccionado/deseleccionado".
 * 
 * @param {number} mid - El ID del modulo al cual pertenece el permiso
 * @param {number} pid - El ID del permiso
 */
export function togglePermission(mid, pid) {

  return {
    type: TOGGLE_SELECTED_PERMISSION,
    payload: { mid, pid }
  };
}


export function initPermissionsSelection() {

  return {
    type: INIT_PERMISSIONS_SELECTION
  };
}

/**
 * Funcion que se encarga "asignar/desasignar" los permisos dados como parametros.
 * 
 * @param {object[]} permissions - Listado de permisos a asignar/desasignar
 */
export function togglePermissions(permissions) {

  return {
    type: TOGGLE_SELECTED_PERMISSIONS,
    payload: { permissions }
  };
}


// WEBPACK FOOTER //
// ./src/core/services/roles/action-creators.js